import { Road } from "./road";
import { Car } from "./car";
import { Visualizer } from "./visualizer";
import { NeuralNetwork } from "./network";

export function main(carCanvas: HTMLCanvasElement, networkCanvas: HTMLCanvasElement) {

    carCanvas.width = 200;
    networkCanvas.width = 300;

    const carCtx = carCanvas.getContext("2d")!;
    const networkCtx = networkCanvas.getContext("2d")!;

    const road = new Road(carCanvas.width / 2, carCanvas.width * 0.9);

    const N = 100;
    const cars = generateCars(N);
    let bestCar = cars[0];
    if (localStorage.getItem("bestBrain")) { 
        for (let i = 0; i < cars.length; i++) { 
            cars[i].brain = JSON.parse(localStorage.getItem("bestBrain")!);
            if (i !== 0) { 
                NeuralNetwork.mutate(cars[i].brain!, 0.2);
            }
        }
    }

    const traffic: Car[] = [new Car(road.getLineCenter(1), -100, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(0), -300, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(2), -300, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(2), -500, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(1), -500, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(0), -700, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(2), -700, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(0), -900, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(2), -900, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(0), -1100, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(1), -1100, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(1), -1300, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(1), -1500, 30, 50, "DUMMY", 0.7),
        new Car(road.getLineCenter(2), -1500, 30, 50, "DUMMY", 0.7),



    ];

    function generateCars(N: number): Car[] { 
        const cars: Car[] = [];
        for (let i = 0; i < N; i++) {
            cars.push(new Car(road.getLineCenter(1), 100, 30, 50, "AI"));
        }
        return cars;
    }

    animate();

    function save() { 
        localStorage.setItem("bestBrain", JSON.stringify(bestCar.brain));
    }

    function discard() { 
        localStorage.removeItem("bestBrain");
    }

    function animate(time: number = 0): void {
        for (let i = 0; i < traffic.length; i++) {
            traffic[i].update(road.borders, []);
        }
        for (let i = 0; i < cars.length; i++) { 
            cars[i].update(road.borders, traffic);
        }

        bestCar = cars.find((car) => car.y === Math.min(...cars.map((c) => c.y)))!;

        carCanvas.height = window.innerHeight - 300;
        networkCanvas.height = window.innerHeight - 300;

        carCtx.save();
        carCtx.translate(0, -bestCar.y + carCanvas.height * 0.7);

        road.draw(carCtx);
        for (let i = 0; i < traffic.length; i++) {
            traffic[i].draw(carCtx, "red");
        }

        carCtx.globalAlpha = 0.2;

        for (let i = 0; i < cars.length; i++) {
            cars[i].draw(carCtx, "blue");
        }

        carCtx.globalAlpha = 1;

        bestCar.draw(carCtx, "blue", true);

        carCtx.restore();

        networkCtx.lineDashOffset = -time / 50;
        if (bestCar.brain) {
            Visualizer.drawNetwork(networkCtx, bestCar.brain);
        }
        requestAnimationFrame(animate);
    }

    return {save, discard};
}

